export const therapies = [
  { id: 'chiropractic', title: 'Chiropractic', image: '/images/theropy/physical-therapy-1_lwsoptimized.webp', description: 'Spinal adjustments for natural pain relief', path: '/therapy/chiropractic' },
  { id: 'agnikarma', title: 'Agnikarma Treatment', image: '/images/theropy/drug_lwsoptimized.webp', description: 'Thermal cauterization treatment', path: '/therapy/agnikarma-treatment' },
  { id: 'ayurveda', title: 'Ayurveda', image: '/images/theropy/ayurvedic_lwsoptimized.webp', description: 'Ancient healing science', path: '/therapy/ayurveda' },
  { id: 'potali-therapy', title: 'Potali Therapy', image: '/images/theropy/Potali_Therapy.webp', description: 'Herbal poultice therapy', path: '/therapy/potali-therapy' },
  { id: 'balanced-therapy', title: 'Balanced Therapy', image: '/images/theropy/physical-therapy-1_lwsoptimized.webp', description: 'Restoring body equilibrium', path: '/therapy/balanced-therapy' },
  { id: 'acupuncture', title: 'Acupuncture Therapy', image: '/images/theropy/acupuncture_lwsoptimized.webp', description: 'Traditional needle therapy', path: '/therapy/acupuncture-therapy' },
  { id: 'cupping-massage', title: 'Cupping Massage', image: '/images/theropy/Cupping Massage.webp', description: 'Suction technique therapy', path: '/therapy/cupping-massage' },
  { id: 'psammo-therapy', title: 'Psammo Therapy', image: '/images/theropy/Psammo_Therapy.webp', description: 'Sand therapy treatment', path: '/therapy/psammo-therapy' },
  { id: 'hammer-therapy', title: 'Hammer Therapy', image: '/images/theropy/hammerthp_lwsoptimized.webp', description: 'Deep tissue percussion therapy', path: '/therapy/hammer-therapy' },
  { id: 'kerala-massage', title: 'Kerala Ayurveda Massage', image: '/images/theropy/physiotherapy_lwsoptimized.webp', description: 'Authentic Ayurvedic bodywork', path: '/therapy/kerala-ayurveda-massage' },
  { id: 'magnetic-therapy', title: 'Magnetic Therapy', image: '/images/theropy/magnetic_lwsoptimized.webp', description: 'Magnetic field healing', path: '/therapy/magnetic-therapy' },
  { id: 'vashpa-sweda', title: 'Vashpa Sweda Chikitsa', image: '/images/theropy/Vashpa Sweda Chikitsa.webp', description: 'Medicated steam therapy', path: '/therapy/vashpa-sweda-chikitsa' },
  { id: 'marma-therapy', title: 'Marma Therapy', image: '/images/theropy/Marma_Therapy.webp', description: 'Vital energy point stimulation', path: '/therapy/marma-therapy' },
  { id: 'naturopathy', title: 'Naturopathy', image: '/images/theropy/nursing_lwsoptimized.webp', description: 'Natural healing sciences', path: '/therapy/naturopathy' },
  { id: 'pichu-ayurvedic', title: 'Pichu Ayurvedic Treatment', image: '/images/theropy/Pichu_Ayurvedic_Treatment.webp', description: 'Oil therapy treatment', path: '/therapy/pichu-ayurvedic-treatment' },
  { id: 'viddhakarma', title: 'Viddhakarma Treatment', image: '/images/theropy/pain_lwsoptimized.webp', description: 'Scraping technique therapy', path: '/therapy/viddhakarma-treatment' }
];

export const servicesData = {
  pillars: [
    { icon: 'FiShield', title: 'Non-Invasive', description: '100% natural treatments without surgery or heavy medication.' },
    { icon: 'FiUser', title: 'Holistic Approach', description: 'Treating the root cause of pain, not just the symptoms.' },
    { icon: 'FiAward', title: 'Expert Care', description: 'Led by Dr. Saurabh Singh with 15+ years of clinical experience.' },
    { icon: 'FiActivity', title: 'Modern Tech', description: 'Combining ancient wisdom with state-of-the-art diagnostic tools.' }
  ],
  treatments: [
    { title: 'Spinal Adjustments', image: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=600', description: 'Precise manual manipulation to restore spinal alignment and nerve function.' },
    { title: 'Nadi Pariksha', image: 'https://images.unsplash.com/photo-1559757175-5700dde675bc?w=600', description: 'Ancient pulse diagnosis to detect imbalances in the body before they manifest as disease.' },
    { title: 'Cupping Therapy', image: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=600', description: 'Suction technique to improve blood flow, reduce inflammation, and relax muscles.' },
    { title: 'Neuro Rehabilitation', image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=600', description: 'Specialized care for stroke, paralysis, and nerve damage recovery.' },
    { title: 'Sports Recovery', image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600', description: 'Fast-track healing for athletic injuries, sprains, and muscle fatigue.' },
    { title: 'Postural Correction', image: 'https://images.unsplash.com/photo-1599447421416-3414502d18a5?w=600', description: 'Realignment programs for tech-neck, scoliosis, and chronic posture issues.' }
  ]
};

export const faqData = [
  { 
    question: "Is Chiropractic Safe?", 
    answer: "Chiropractic care is generally considered safe when performed by a qualified and licensed chiropractor. To ensure safety, it's essential to seek treatment from a licensed practitioner. Dr. Saurabh Singh conducts a thorough assessment of medical history and physical condition before any adjustment. While rare, mild side effects like temporary soreness may occur as the body adjusts. Patients with pre-existing conditions like osteoporosis should always discuss these beforehand for tailored care." 
  },
  { 
    question: "What is Jiva Nadi Therapy?", 
    answer: "Jiva Nadi Therapy is our signature holistic healing method that combines the ancient wisdom of pulse diagnosis (Nadi Pariksha) with modern structural correction. It focuses on identifying and treating energy blockages and structural misalignments to restore the body's natural vitality and healing capacity." 
  },
  { 
    question: "Why Choose Jiva Nadi Therapy & Chiropractor Center?", 
    answer: "We offer a unique 360-degree healing ecosystem. Unlike centers that only focus on one modality, we integrate Chiropractic, Ayurveda, and Naturopathy. Our high success rate with 30,000+ patients and our focus on non-surgical, drug-free recovery makes us the premier choice in Mumbai." 
  },
  { 
    question: "Why Choose Dr. Saurabh Chiropractor Center?", 
    answer: "Dr. Saurabh Singh is an OMT London certified expert with 15+ years of experience. He is one of the few practitioners in India to hold a membership in the Minnesota Chiropractic Association (USA), bringing international standards of spinal care to local patients." 
  },
  { 
    question: "Why Did Dr. Saurabh Take Only 12 Appointments in a day?", 
    answer: "To ensure the highest quality of care. Each patient at JIVA NADI receives an intensive diagnostic and treatment session. By limiting appointments to 12 per day, Dr. Saurabh ensures he is fully focused on each individual's complex recovery process, maintaining our standard of excellence over quantity." 
  },
  { 
    question: "What is a Chiropractor?", 
    answer: "A Chiropractor is a healthcare professional focused on the diagnosis and treatment of neuromuscular disorders, with an emphasis on treatment through manual adjustment and/or manipulation of the spine to reduce pain and improve functionality." 
  },
  { 
    question: "Best Chiropractor Near Me?", 
    answer: "JIVA NADI centers are strategically located across Mumbai (Mulund), Pune (Kamshet), Hyderabad, Azamgarh, and Raipur. Led by Dr. Saurabh Singh, we are consistently rated as the top destination for non-surgical spinal care." 
  },
  { 
    question: "What are the steps used in chiropractic treatment?", 
    answer: "1. Detailed Consultation & History, 2. Nadi Pariksha (Pulse Diagnosis), 3. Physical & Orthopedic Assessment, 4. Precision Spinal Adjustment, 5. Post-adjustment Rehabilitation & Lifestyle Advice." 
  },
  { 
    question: "Walk in Chiropractor Near Me?", 
    answer: "While we recommend booking appointments due to high demand, our centers are open from 10:00 AM to 09:00 PM. Please call 9581556660 to check for same-day availability." 
  },
  { 
    question: "What are the Benefits of a Chiropractor?", 
    answer: "Benefits include significant pain reduction (back, neck, joint), improved mobility, better posture, enhanced nerve function, improved sleep, and a stronger immune system by removing interference from the nervous system." 
  },
  { 
    question: "Top Chiropractor Near Me?", 
    answer: "Dr. Saurabh Singh's JIVA NADI is recognized as a top-tier facility due to its integration of modern chiropractic science with ancient Indian healing traditions, serving patients from across 5 states." 
  },
  { 
    question: "Chiropractor and Physiotherapist", 
    answer: "While both treat pain, a Chiropractor focuses on the relationship between the spine and nervous system (alignment), whereas a Physiotherapist focuses more on muscle strength and soft tissue rehabilitation. At JIVA NADI, we often use both for optimal results." 
  },
  { 
    question: "Affordable Chiropractor Near Me", 
    answer: "We offer transparent pricing and multiple treatment packages to make world-class chiropractic care accessible without compromising on the quality or time spent with each patient." 
  },
  { 
    question: "Chiropractic Adjustment with Massage Near Me", 
    answer: "Our signature 'Balanced Therapy' combines precision chiropractic adjustments with deep tissue Kerala Ayurvedic massage or Hammer therapy for comprehensive relief of both structure and muscle." 
  },
  { 
    question: "Why do adjustments sometimes make a popping sound?", 
    answer: "The 'pop' is simply the release of gas (oxygen, nitrogen, and CO2) from the joint fluid. It’s similar to cracking your knuckles and is a normal, painless part of the pressure change during an adjustment." 
  },
  { 
    question: "What does a Chiropractor do?", 
    answer: "A chiropractor uses controlled force to adjust joints that have become restricted in their movement (subluxations), helping to restore alignment, reduce nerve pressure, and allow the body to heal naturally." 
  },
  { 
    question: "What people look for when they search for chiropractors?", 
    answer: "Patients typically look for experience (15+ years), qualification (OMT London), patient reviews (4.9★), non-surgical approach, and convenient locations—all of which JIVA NADI provides." 
  },
  { 
    question: "How to Take a Chiropractic Doctor's Appointment?", 
    answer: "You can book via our website, call us directly at 9581556660, or send a WhatsApp message. Our coordinators will help you find the earliest slot available with Dr. Saurabh." 
  },
  { 
    question: "What is Kerala Ayurveda massage?", 
    answer: "It is a traditional Ayurvedic bodywork that uses medicated herbal oils and specific strokes to improve circulation, detoxify the body, and relax deeply seated muscle tension." 
  },
  { 
    question: "What is Cupping Treatment?", 
    answer: "Cupping uses suction to pull blood to the surface of the skin, which helps stimulate blood flow, draw out toxins, and release tight fascia around the muscles." 
  },
  { 
    question: "What is Acupuncture Treatment?", 
    answer: "Acupuncture involves inserting very thin needles at specific points on the body to balance energy flow (Qi), trigger natural painkillers, and improve the body's healing response." 
  },
  { 
    question: "What is Hammer Treatment?", 
    answer: "Also known as Tok Sen, it uses rhythmic tapping with a wooden hammer and wedge to create deep healing vibrations that penetrate through muscle layers to clear energy blockages." 
  },
  { 
    question: "What is NADI PARIKSHA (PULSE DIAGNOSIS)?", 
    answer: "It is an ancient Ayurvedic technique of diagnosing the body's internal health and imbalances by feeling the pulse at the wrist. It can detect issues before they manifest as physical pain." 
  },
  { 
    question: "History of NADI PARIKSHA (PULSE DIAGNOSIS)?", 
    answer: "Nadi Pariksha has been part of Indian traditional medicine for over 5,000 years. It was documented in ancient texts like the Sharngadhara Samhita and has been passed down through generations of Vaidyas as the ultimate diagnostic tool." 
  }
];

export const pageContent = {
  default: {
    hero: { title: "Holistic Healing", subtitle: "Natural Restoration", description: "Experience the power of non-surgical treatment.", image: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=1200" },
    intro: { heading: "About This Therapy", content: ["Our treatments focus on activating the body's natural healing capabilities."] },
    benefits: { physical: ["Pain Relief", "Better Mobility"], emotional: ["Reduced Stress", "Mental Clarity"] },
    techniques: [{ name: "Standard Care", purpose: "General wellness" }],
    idealFor: { heading: "Who is this for?", points: [{ title: "Chronic Pain", desc: "Long-standing issues." }] }
  },
  chiropractic: {
    hero: { title: "Advanced", subtitle: "Chiropractic Care", description: "Realign your spine, restore your nervous system, and reclaim a pain-free life without surgery.", image: "https://images.unsplash.com/photo-1599447421416-3414502d18a5?w=1200" },
    intro: { heading: "The Science of Alignment", content: ["Chiropractic care focuses on the diagnosis and treatment of neuromuscular disorders, emphasizing treatment through manual adjustment and manipulation of the spine.", "Our approach reduces pain and improves functionality by educating the patient on how they can account for their own health via ergonomics and exercise."] },
    benefits: { physical: ["Improved Joint Mobility", "Decreased Muscle Degeneration", "Better Circulation", "Enhanced Nerve Function"], emotional: ["Stress Reduction", "Improved Sleep Quality", "Mental Clarity", "Anxiety Relief"] },
    techniques: [{ name: "Diversified Technique", purpose: "Classic manual adjustment" }, { name: "Activator Method", purpose: "Gentle instrument-assisted adjusting" }, { name: "Drop Table", purpose: "Low-force spinal correction" }, { name: "Gonstead", purpose: "Precise structural analysis" }],
    idealFor: { heading: "Perfect For Treating", points: [{ title: "Back & Neck Pain", desc: "Chronic discomfort from desk jobs or injuries." }, { title: "Sciatica", desc: "Nerve pain radiating down the leg." }, { title: "Headaches", desc: "Tension and migraines caused by neck alignment." }, { title: "Sports Injuries", desc: "Performance enhancement and recovery." }] },
    stats: { satisfaction: "98%", statDesc: "Patients report immediate relief after first session" }
  },
  "balanced-therapy": {
    hero: { title: "Restorative", subtitle: "Balanced Therapy", description: "A unique fusion of osteopathy and physiotherapy to bring your body back to perfect equilibrium.", image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=1200" },
    intro: { heading: "Finding Your Balance", content: ["Balanced Therapy is our signature integrative approach that addresses structural imbalances affecting the musculoskeletal system.", "By correcting asymmetries in the body, we relieve uneven pressure on joints and muscles, preventing long-term wear and tear."] },
    benefits: { physical: ["Postural Correction", "Core Strengthening", "Muscle Symmetry", "Joint Stability"], emotional: ["Confidence Boost", "Body Awareness", "Relaxation", "Mood Elevation"] },
    techniques: [{ name: "Myofascial Release", purpose: "Releasing tight tissue restrictions" }, { name: "Kinetic Chain", purpose: "Aligning movement patterns" }],
    idealFor: { heading: "Recommended For", points: [{ title: "Scoliosis", desc: "Managing spinal curvature." }, { title: "Uneven Hips", desc: "Correcting pelvic tilt." }] }
  },
  "hammer-therapy": {
    hero: { title: "Deep Tissue", subtitle: "Hammer Therapy", description: "Ancient Tok Sen technique using rhythmic tapping to release deep-seated tension and energy blockages.", image: "https://images.unsplash.com/photo-1600334019640-ebc96cee0a25?w=1200" },
    intro: { heading: "Rhythmic Healing", content: ["Hammer Therapy, or Tok Sen, is an ancient Thai therapy that uses a wooden hammer and wedge to create healing vibrations affecting the deep muscle layers and bones.", "These mechanical vibrations penetrate deeper than manual massage, clearing blocked energy lines."] },
    benefits: { physical: ["Deep Muscle Release", "Improved Circulation", "Nerve Stimulation", "Scar Tissue Breakdown"], emotional: ["Deep Relaxation", "Energy Flow", "Trauma Release", "Grounding"] },
    techniques: [{ name: "Rhythmic Tapping", purpose: "Vibration therapy" }, { name: "Meridian Clearing", purpose: "Energy pathway opening" }],
    idealFor: { heading: "Effective For", points: [{ title: "Chronic Stiffness", desc: "Frozen shoulders and rigid backs." }, { title: "Nerve Impingement", desc: "Releasing trapped nerves." }] }
  }
};

export const coursesData = [
  { 
    title: "Chiropractic Excellence", 
    duration: "6 Months", 
    level: "Professional Certification", 
    desc: "Master the art of spinal adjustments and holistic diagnosis with Dr. Saurabh Singh.",
    price: "₹45,000",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=600"
  },
  { 
    title: "Nadi Pariksha Specialist", 
    duration: "3 Months", 
    level: "Advanced Practitioner", 
    desc: "Ancient pulse diagnosis techniques translated for modern clinical settings.",
    price: "₹25,000",
    image: "https://images.unsplash.com/photo-1559757175-5700dde675bc?w=600"
  },
  { 
    title: "Holistic Pain Coach", 
    duration: "4 Months", 
    level: "Healthcare Career", 
    desc: "Comprehensive training in non-surgical pain management and patient counseling.",
    price: "₹35,000",
    image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600"
  }
];

export const videoTestimonials = [
  { title: "Serious Sciatica Relief", youtubeId: "ScMzIvxBSi4", category: "Sciatica", patient: "Rahul M." },
  { title: "Chronic Neck Pain Fix", youtubeId: "ScMzIvxBSi4", category: "Cervical", patient: "Sneha P." },
  { title: "Frozen Shoulder Recovery", youtubeId: "ScMzIvxBSi4", category: "Shoulder", patient: "Amit K." },
  { title: "Disc Bulge Non-Surgical", youtubeId: "ScMzIvxBSi4", category: "Spine", patient: "Vikram S." },
  { title: "Paralysis Rehab Success", youtubeId: "ScMzIvxBSi4", category: "Neuro", patient: "Anjali G." },
  { title: "Knee Pain Transformation", youtubeId: "ScMzIvxBSi4", category: "Knee", patient: "Sanjay T." }
];

export const galleryImages = [
  { url: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=800", title: "Advanced Spine Diagnostic" },
  { url: "https://images.unsplash.com/photo-1599447421416-3414502d18a5?w=800", title: "Manual Adjustment Session" },
  { url: "https://images.unsplash.com/photo-1559757175-5700dde675bc?w=800", title: "Nadi Pariksha Expert" },
  { url: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=800", title: "Modern Rehab Center" },
  { url: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800", title: "Cervical Care Unit" },
  { url: "https://images.unsplash.com/photo-1600334019640-ebc96cee0a25?w=800", title: "Doctor Consultation" }
];

export const blogPosts = [
  {
    id: 1,
    slug: 'understanding-chiropractic-care',
    title: 'Understanding Chiropractic Care: A Complete Guide',
    excerpt: 'Learn about the fundamentals of chiropractic care, how it works, and what to expect from your first visit.',
    content: `
      <h2>What is Chiropractic Care?</h2>
      <p>Chiropractic care is a healthcare discipline that focuses on the relationship between the body's structure—mainly the spine—and its functioning. Chiropractors believe that proper alignment of the body's musculoskeletal structure, particularly the spine, will enable the body to heal itself without surgery or medication.</p>

      <h2>How Does Chiropractic Treatment Work?</h2>
      <p>Chiropractic treatment involves manual adjustment of the spine and other joints to restore proper alignment and function. This helps reduce pain, improve mobility, and promote overall health.</p>

      <h2>Benefits of Chiropractic Care</h2>
      <ul>
        <li>Relief from back and neck pain</li>
        <li>Improved posture</li>
        <li>Enhanced mobility and flexibility</li>
        <li>Better nervous system function</li>
        <li>Reduced stress and tension</li>
      </ul>
    `,
    image: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=800',
    category: 'Chiropractic',
    author: 'Dr. Saurabh Singh',
    publishedAt: '2024-01-15',
    readTime: '5 min read',
    tags: ['chiropractic', 'spine-health', 'pain-relief'],
    featured: true
  },
  {
    id: 2,
    slug: 'nadi-pariksha-ancient-healing',
    title: 'Nadi Pariksha: Ancient Pulse Diagnosis for Modern Healing',
    excerpt: 'Discover the ancient art of Nadi Pariksha and how it helps identify health imbalances before they manifest as diseases.',
    content: `
      <h2>The Science of Nadi Pariksha</h2>
      <p>Nadi Pariksha is an ancient Ayurvedic diagnostic technique that involves reading the pulse to understand the body's internal balance. This non-invasive method can detect imbalances in the body's doshas and provide insights into overall health.</p>

      <h2>How Nadi Pariksha Works</h2>
      <p>Through careful analysis of the pulse at various points on the wrist, practitioners can identify:</p>
      <ul>
        <li>Imbalances in Vata, Pitta, and Kapha doshas</li>
        <li>Organ function and health</li>
        <li>Nutritional deficiencies</li>
        <li>Stress levels and mental health</li>
      </ul>

      <h2>Benefits in Modern Healthcare</h2>
      <p>Nadi Pariksha complements modern diagnostic tools by providing early detection of health issues and personalized treatment approaches.</p>
    `,
    image: 'https://images.unsplash.com/photo-1559757175-5700dde675bc?w=800',
    category: 'Ayurveda',
    author: 'Dr. Saurabh Singh',
    publishedAt: '2024-01-10',
    readTime: '4 min read',
    tags: ['nadi-pariksha', 'ayurveda', 'diagnosis'],
    featured: true
  },
  {
    id: 3,
    slug: 'back-pain-causes-solutions',
    title: 'Common Causes of Back Pain and Effective Solutions',
    excerpt: 'Explore the most common causes of back pain and learn about effective, non-surgical treatment options available at Jiva Nadi.',
    content: `
      <h2>Understanding Back Pain</h2>
      <p>Back pain is one of the most common health complaints worldwide, affecting millions of people. While it can be debilitating, most cases can be effectively treated with proper care and treatment.</p>

      <h2>Common Causes</h2>
      <ul>
        <li>Poor posture and ergonomics</li>
        <li>Muscle strain and sprains</li>
        <li>Herniated discs</li>
        <li>Spinal misalignment</li>
        <li>Degenerative conditions</li>
      </ul>

      <h2>Our Treatment Approach</h2>
      <p>At Jiva Nadi, we combine chiropractic adjustments, Ayurvedic therapies, and rehabilitation exercises to provide comprehensive back pain relief.</p>
    `,
    image: 'https://images.unsplash.com/photo-1599447421416-3414502d18a5?w=800',
    category: 'Pain Management',
    author: 'Dr. Saurabh Singh',
    publishedAt: '2024-01-05',
    readTime: '6 min read',
    tags: ['back-pain', 'pain-relief', 'treatment'],
    featured: false
  },
  {
    id: 4,
    slug: 'sports-injury-recovery',
    title: 'Sports Injury Recovery: Getting Back in the Game Faster',
    excerpt: 'Learn how our integrated approach helps athletes recover from injuries and prevent future problems.',
    content: `
      <h2>Sports Injuries We Treat</h2>
      <p>Our specialized sports injury recovery program addresses:</p>
      <ul>
        <li>Sprains and strains</li>
        <li>Tendonitis</li>
        <li>Muscle tears</li>
        <li>Joint injuries</li>
        <li>Overuse injuries</li>
      </ul>

      <h2>Recovery Process</h2>
      <p>Our comprehensive recovery program includes assessment, treatment, rehabilitation, and prevention strategies to ensure athletes return to their sport safely and stronger.</p>
    `,
    image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800',
    category: 'Sports Medicine',
    author: 'Dr. Saurabh Singh',
    publishedAt: '2023-12-28',
    readTime: '5 min read',
    tags: ['sports-injury', 'recovery', 'athletes'],
    featured: false
  },
  {
    id: 5,
    slug: 'preventive-healthcare-importance',
    title: 'The Importance of Preventive Healthcare in Today\'s World',
    excerpt: 'Why regular health check-ups and preventive care are crucial for maintaining optimal health and preventing chronic conditions.',
    content: `
      <h2>Why Prevention Matters</h2>
      <p>Preventive healthcare focuses on maintaining health and preventing disease rather than treating illnesses after they occur. This approach is particularly important in our modern lifestyle.</p>

      <h2>Our Preventive Services</h2>
      <ul>
        <li>Regular health assessments</li>
        <li>Posture and spinal screenings</li>
        <li>Nutritional guidance</li>
        <li>Stress management techniques</li>
        <li>Lifestyle counseling</li>
      </ul>
    `,
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800',
    category: 'Preventive Care',
    author: 'Dr. Saurabh Singh',
    publishedAt: '2023-12-20',
    readTime: '4 min read',
    tags: ['preventive-care', 'health', 'wellness'],
    featured: false
  },
  {
    id: 6,
    slug: 'stress-management-techniques',
    title: 'Effective Stress Management Techniques for Better Health',
    excerpt: 'Discover natural ways to manage stress and improve your overall well-being through holistic approaches.',
    content: `
      <h2>The Impact of Stress</h2>
      <p>Chronic stress can lead to various health issues including musculoskeletal pain, digestive problems, and weakened immune function.</p>

      <h2>Our Stress Management Solutions</h2>
      <ul>
        <li>Mindfulness and meditation</li>
        <li>Breathing exercises</li>
        <li>Relaxation techniques</li>
        <li>Holistic therapies</li>
        <li>Lifestyle modifications</li>
      </ul>
    `,
    image: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=800',
    category: 'Mental Health',
    author: 'Dr. Saurabh Singh',
    publishedAt: '2023-12-15',
    readTime: '5 min read',
    tags: ['stress-management', 'mental-health', 'wellness'],
    featured: false
  }
];

export const blogCategories = [
  { id: 'chiropractic', name: 'Chiropractic', count: 1 },
  { id: 'ayurveda', name: 'Ayurveda', count: 1 },
  { id: 'pain-management', name: 'Pain Management', count: 1 },
  { id: 'sports-medicine', name: 'Sports Medicine', count: 1 },
  { id: 'preventive-care', name: 'Preventive Care', count: 1 },
  { id: 'mental-health', name: 'Mental Health', count: 1 }
];